import axios from "axios";
import { API_URLS } from "./API_URLS";
const FormService = {
    //API Handling for Contact Form
    ContactForm: (postdata) => {
        let api = new API_URLS();
        let url = api.getContactFormURL();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    },
    //API Handling for Quote Form
    QuoteForm: (postdata) => {
        let api = new API_URLS();
        let url = api.getQuoteFormUrl();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    }
    ,
    RequestForm: (postdata) => {
        let api = new API_URLS();
        let url = api.getrequestFormUrl();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    }
    ,
    NewsletterForm: (postdata) => {
        let api = new API_URLS();
        let url = api.getNewsletterForm();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    },
    getCareerForm: (postdata) => {
        let api = new API_URLS();
        let url = api.getCareerForm();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    },
    Getldpform: (postdata) => {
        let api = new API_URLS();
        let url = api.getldpform();
        return axios.post(url, postdata, { 'content-type': 'application/json' }).then((data) => {
            return data;
        })
    }
}

export default FormService;